import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Job } from './job.resource';
import { Platform } from './platform.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';

@Resource({
  type: 'customfields',
})
export class CustomField extends AtomResource {
  @Attribute() name?: string;
  @Attribute() validation?: 'number' | 'string' | 'date' | 'json' | 'boolean';
  @Attribute() label?: string;
  @Attribute() desc?: string;
  @Attribute() model?: 'contracts' | 'catalogs' | 'skus';
  @Attribute() required?: boolean;
  @Attribute() overload?: boolean;
  @Attribute() editable?: boolean;

  @Relationship() billingprovider?: Job;
  @Relationship() platform?: Platform;
}

export class CustomFieldConfig implements ResourceConfig {
  hosted = 'platform';
  tables = {
    options: {
      copy: true,
    },
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'Name',
        displayedDatas: [{ path: ['name'], class: 'label' }],
        header: 'Name',
        displayed: true,
      },
      {
        columnDef: 'validation',
        displayedDatas: [{ path: ['validation'] }],
        header: 'Type',
        displayed: true,
      },
      {
        columnDef: 'model',
        displayedDatas: [{ path: ['model'] }],
        header: 'Model',
        displayed: true,
      },
      {
        columnDef: 'required',
        displayedDatas: [{ path: ['required'], type: 'boolean' }],
        header: 'Required',
        displayed: true,
      },
      {
        columnDef: 'editable',
        displayedDatas: [{ path: ['editable'], type: 'boolean' }],
        header: 'Editable',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'text_fields',
      title: [
        {
          path: ['name'],
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        list: [
          {
            title: 'Name',
            APIKey: 'name',
            value: {
              path: ['name'],
            },
          },
          {
            title: 'Type',
            APIKey: 'validation',
            value: {
              path: ['validation'],
            },
          },
          {
            title: 'Model',
            APIKey: 'model',
            value: {
              path: ['model'],
            },
          },
          {
            title: 'Required',
            APIKey: 'required',
            value: {
              path: ['required'],
              type: 'boolean',
            },
          },
          {
            title: 'Editable',
            APIKey: 'editable',
            value: {
              path: ['editable'],
              type: 'boolean',
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Custom Fields',
        formGroup: 'customfields',
        list: [
          {
            type: 'text',
            title: 'Name',
            formControl: 'name',
            APIKey: 'name',
            required: true,
          },
          {
            type: 'text',
            title: 'Label',
            formControl: 'label',
            APIKey: 'label',
            required: true,
          },
          {
            type: 'fixlist',
            title: 'Type',
            formControl: 'validation',
            APIKey: 'validation',
            required: true,
            fixlistValues: [
              { code: 'numbers', label: 'Number Field' },
              { code: 'string', label: 'Text Field' },
              { code: 'date', label: 'Date Picker' },
              { code: 'json', label: 'JSON Editor' },
              { code: 'boolean', label: 'Checkbox' },
            ],
            noCols: true,
          },
          {
            type: 'fixlist',
            title: 'Model',
            formControl: 'model',
            APIKey: 'model',
            required: true,
            fixlistValues: [
              { code: 'contracts', label: 'Contracts' },
              { code: 'catalogs', label: 'Catalogs' },
              { code: 'skus', label: 'SKU' },
            ],
            noCols: true,
          },
          {
            type: 'text',
            title: 'Description',
            formControl: 'desc',
            APIKey: 'desc',
            noCols: true,
          },
          {
            type: 'boolean',
            title: 'Required',
            APIKey: 'required',
            formControl: 'required',
          },
          // {
          //   type: 'boolean',
          //   title: 'Overwritable',
          //   APIKey: 'overload',
          //   formControl: 'overload',
          // },
          {
            type: 'boolean',
            title: 'Editable',
            APIKey: 'editable',
            formControl: 'editable',
          },
          {
            type: 'ghost',
            formControl: 'billingprovider',
            APIKey: 'platform.job',
          },
        ],
      },
    ],
  };
  resource = CustomField;
  resourceName = 'Custom Field';
  resourceKey = 'customfields';
  resourceKeySingle = 'customfield';
  includes = ['platform.job'];
}
